import React, { FC, useCallback, useState } from 'react'
import Lightbox from 'react-image-lightbox';
import { IPlaidInformation } from 'src/services/types';

interface IProps {
    validatedInformation: IPlaidInformation | null;
    workIdImageFrontPath: string;
    workIdImageBackPath: string;
    firstName: string;
    lastName: string;
    isVerified: boolean | null;
}

export const PlaidInformation: FC<IProps> = ({ 
    validatedInformation,
    workIdImageFrontPath,
    workIdImageBackPath,
    firstName,
    lastName,
    isVerified,
 }) => {

    const [imageActive, setImageActive] = useState<string | null>(null);
    const [photoIndex, setphotoIndex] = useState<any>(0);

    const formatDocumentType = useCallback((type: string) => {
        return type.replace(/_/g, ' ').toUpperCase();
    } ,[]);

  return (
    <>
      <div className='row'>
            <div className='col-sm-4'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <h6 style={{color: '#b4926f'}}>Full Name:</h6>
                        <p>{validatedInformation?.name?.first_name || firstName} {validatedInformation?.name?.last_name || lastName}</p>
                    </div>
                    <div className='col-sm-12'>
                        <h6 style={{color: '#b4926f'}}> Date of Birth:</h6>
                        <p>{validatedInformation?.date_of_birth || '-'}</p>
                    </div>
                </div>
            </div>
            <div className='col-sm-4'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <h6 style={{color: '#b4926f'}}>Phone number:</h6>
                        <p>{validatedInformation?.phone_number || '-'}</p>
                    </div>
                    <div className='col-sm-12'>
                        <h6 style={{color: '#b4926f'}}>SSN (last 4 numbers):</h6>
                        <p>{validatedInformation?.ssn_last_4 || '-'}</p>
                    </div>
                </div>
            </div>
            <div className='col-sm-4'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <h6 style={{color: '#b4926f'}}>Status:</h6>
                        <div 
                            className={`px-3 d-flex justify-content-center align-items-center rounded`}
                            style={{ 
                                backgroundColor: isVerified === null ? '#e6e7e8' : ( isVerified ? '#d4f2d5' : '#ffd4d4'),
                                height: '30px', 
                                margin: 'auto' 
                            }}
                        >
                            <h6 className='pt-1'>{isVerified === null ? 'Not started' : (isVerified ? 'Success' : 'Failed')}</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='row mt-3'>
            {
                validatedInformation?.documents.map((doc, index) => (
                    
                <div className='col-sm-12 p-2 rounded' key={index} style={{backgroundColor: '#f9f9f9'}}>
                    <div className='row'>
                        <div className='col-sm-4'>
                            <div>
                                <h6 style={{color: '#b4926f'}}>Document:</h6>
                                <b>{formatDocumentType(doc?.type)}</b> 
                            </div>
                            <small>(attempt {index+1})</small>
                        </div>
                        <div className='col-sm-4'>
                            <h6 style={{color: '#b4926f'}}>Image Front:</h6>
                            <img 
                                onClick={() => {
                                        setImageActive(doc?.images?.original_front);
                                        setphotoIndex(0);
                                    }}
                                src={doc?.images?.original_front} 
                                alt="" 
                                className='rounded-3 img-fluid'
                                style={{cursor: 'pointer'}}                                            
                                width={120} 
                            />
                        </div>
                        <div className='col-sm-4'>
                            <h6 style={{color: '#b4926f'}}>Image Back:</h6>
                            <img 
                                onClick={() => {
                                        setImageActive(doc?.images?.original_back);
                                        setphotoIndex(0);
                                    }}
                                src={doc?.images?.original_back} 
                                alt="" 
                                className='rounded-3 img-fluid'
                                style={{cursor: 'pointer'}}                                            
                                width={120} 
                            />
                        </div>
                    </div>
                </div>
                ))
            }
        </div>

        <div className='row' >
            <div className='col-sm-12 mt-3 p-2 rounded' style={{backgroundColor: '#f9f9f9'}}>
                <div className='row'>
                    <div className='col-sm-4'>
                        <h6 style={{color: '#b4926f'}}>Document:</h6>
                        <b>WORK ID</b>
                    </div>
                    <div className='col-sm-4'>
                        <h6 style={{color: '#b4926f'}}>Image Front:</h6>
                        {
                            workIdImageFrontPath ?
                            <img 
                                onClick={() => {
                                        setImageActive(workIdImageFrontPath || null);
                                    }}
                                src={workIdImageFrontPath} 
                                alt="" 
                                className='rounded-3 img-fluid'
                                style={{cursor: 'pointer'}}                                            
                                width={120} 
                            /> : 
                            <div>Not Available</div>
                        }
                    </div>
                    <div className='col-sm-4'>
                        <h6 style={{color: '#b4926f'}}>Image Back:</h6>
                        {
                            workIdImageBackPath ?
                            <img 
                                onClick={() => {
                                        setImageActive(workIdImageBackPath || null);
                                    }}
                                src={workIdImageBackPath} 
                                alt="" 
                                className='rounded-3 img-fluid'
                                style={{cursor: 'pointer'}}                                            
                                width={120} 
                            /> :
                            <div>Not Available</div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div className='row mt-3 rounded p-2' style={{backgroundColor: '#f9f9f9'}}>
            <h6 style={{color: '#b4926f'}}>
                Selfie
            </h6>
        
            <div className='col-sm-12'>
                <div className='row'>
                    <div className='col-sm-12 d-flex justify-content-center align-items-center'>
                        {
                            validatedInformation?.selfie?.video_url ? (
                            <video width="350" height="350" controls>
                                {
                                    (typeof(validatedInformation?.selfie?.video_url) === 'string' && validatedInformation?.selfie?.video_url.includes(".mp4")) &&
                                    <source src={validatedInformation?.selfie?.video_url} type="video/mp4" />
                                }
                                {
                                    (typeof(validatedInformation?.selfie?.video_url) === 'string' && validatedInformation?.selfie?.video_url.includes(".webm")) &&
                                    <source src={validatedInformation?.selfie?.video_url} type="video/webm" />
                                }
                                
                            </video>
                            ) : <div>Not Available</div>
                        }
                    </div>
                </div>
            </div>
        </div>

        {imageActive ? (
            <Lightbox
            mainSrc={imageActive}
            enableZoom={true}
            onCloseRequest={() => {
                setImageActive(null);
            }}
            imageCaption={"Image " + parseFloat(photoIndex + 1)}
            />
        ) : null}
    </>
  )
}